import { render } from "./DeleteDialog.vue?vue&type=template&id=ab0994fa"
import script from "./DeleteDialog.vue?vue&type=script&lang=js"
export * from "./DeleteDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/DeleteDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ab0994fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ab0994fa', __exports__)) {
    api.reload('ab0994fa', __exports__)
  }
  
  module.hot.accept("./DeleteDialog.vue?vue&type=template&id=ab0994fa", () => {
    api.rerender('ab0994fa', render)
  })

}


export default __exports__